import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'ng-sms-message',
    template: `
      <div
          style="background-image: url(/img/communications/phonebackground.png); width: 709px; height: 604px; margin:auto;">
        <div style="font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
                color: #64757d;
                position: absolute;
                font-size: 25px;
                line-height: 23px;
                margin-left: 155px;
                margin-top: 128px;
                margin-bottom: 20px;">
          Characters: {{message.length}}
        </div>
        <div style="font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
                color: #64757d;
                position: absolute;
                font-size: 25px;
                line-height: 23px;
                margin-left: 375px;
                margin-top: 128px;
                margin-bottom: 20px;">
          Messages: {{getMessagesByCharacters()}}
        </div>
        <div style="white-space: pre-wrap;
                font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
                position: absolute;
                font-size: 42px;
                line-height: 47px;
                margin-left: 85px;
                margin-top: 157px;
                margin-bottom: 20px;
                width: 543px;
                height: 428px;
                overflow: scroll;">
          {{message}}
        </div>
        <div id="printdiv" 
             style="display: none;
             white-space: pre-wrap;
                font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
                position: absolute;
                font-size: 42px;
                line-height: 47px;
                margin-left: 85px;
                margin-top: 157px;
                margin-bottom: 20px;
                width: 543px;">
          {{message}}
        </div>
      </div>    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SMSMessageComponent {

    @Input() readonly editable: boolean;
    @Input() readonly message: string;

    getMessagesByCharacters(): number {
        const charsPerMessage = 160;

        return Math.ceil(this.message.length / charsPerMessage);
    }
}